import { MessageCircleQuestion, Sparkles } from "lucide-react";

// La morale de la fable, en grand, avec une question pour en parler.
export default function FableMorale({ story }) {
  if (story.kind !== "fable" || !story.morale) return null;
  return (
    <section className="mt-10 rounded-[2rem] bg-amber-50 border-4 border-amber-200 p-8 text-center soft-in" data-testid="fable-morale">
      <p className="text-sm uppercase tracking-[0.25em] text-amber-700 mb-3 flex items-center justify-center gap-2"><Sparkles className="w-4 h-4" /> La morale</p>
      <p className="font-serif-display italic text-3xl sm:text-4xl leading-snug text-amber-950 whitespace-pre-line" data-testid="fable-morale-text">{story.morale.trim().replace(/\s*[:;,]$/, ".")}</p>
      {story.morale_question && (
        <div className="mt-8 rounded-2xl bg-white border-2 border-amber-100 p-5 inline-flex items-start gap-3 text-left max-w-2xl" data-testid="fable-morale-question">
          <MessageCircleQuestion className="w-8 h-8 text-emerald-700 shrink-0" />
          <p className="font-patient text-2xl text-gray-800">{story.morale_question}</p>
        </div>
      )}
    </section>
  );
}
